import { Component, EventEmitter, ElementRef, Input, Output, forwardRef, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	selector: 'bb-icon-toggle',
	templateUrl: './bb-icon-toggle.component.html',
	styleUrls: ['./bb-icon-toggle.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BbIconToggleComponent),
		multi: true
	}]
})

export class BbIconToggleComponent implements ControlValueAccessor, OnInit {
	@Input() checked = false;
	@Input() disabled = false;
	@Input() partial = false;
	@Input() trueValue: string | boolean;
	@Input() falseValue: string | boolean;
	@Input() defaultValue: any;
	@Output() onChanged = new EventEmitter<any>();

	el: HTMLElement;
	propagateChange: any;
	modelValue: string | boolean;

	constructor(private _eref: ElementRef) {
		this.el = this._eref.nativeElement;
	}

	ngOnInit() {
		if (this.el.parentNode) {
			const parent = (this.el.parentNode as HTMLElement);

			if (parent.tagName === 'LABEL') {
				parent.onclick = (e) => {
					e.stopPropagation();
					this.clicked(e);
				};
			}
		}

		this.el.onclick = (e) => {
			e.stopPropagation();
			this.clicked(e);
		};
	}

	clicked(e: Event) {
		if (this.disabled) {
			return;
		}

		this.checked = !this.checked;

		if (this.trueValue && typeof this.trueValue !== 'boolean') {
			this.modelValue = this.checked ? this.trueValue : this.falseValue;
		} else {
			this.modelValue = !!this.checked;
		}

		const propValue = this.modelValue || this.checked;
		if (typeof this.propagateChange !== 'undefined') {
			this.propagateChange(propValue);
		}

		this.onChanged.emit(propValue);

	}

	writeValue(value: any) {
		if (this.trueValue && value === this.trueValue) {
			this.checked = true;
		} else if (this.falseValue && value === this.falseValue) {
			this.checked = false;
		} else if (typeof value === 'undefined' && typeof this.defaultValue !== 'undefined' && this.defaultValue !== null) {
			this.checked = this.trueValue ? this.trueValue === this.defaultValue : !!this.defaultValue;
		} else {
			this.checked = !!value;
		}
	}

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	registerOnTouched() {

	}
}
